import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col pb-16">
      <div className="max-w-3xl mx-auto py-12 px-4 text-center flex-1">
        <h1 className="text-4xl font-bold mb-4 text-primary">Welcome to ArtistDesk</h1>
        <p className="text-lg text-secondary mb-6">
          Discover seamless booking, talented makeup artists, and a modern platform designed for your beauty needs.
        </p>
        <div className="mb-8">
          <button
            onClick={() => navigate('/signup')}
            className="btn-primary px-8 py-3 text-lg"
          >
            Signup as Artist
          </button>
        </div>
      <div className="grid gap-8 md:grid-cols-2 mt-8">
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-2 text-primary">For Clients</h2>
          <p className="text-secondary">Book appointments, explore services, and find the perfect artist for your occasion.</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-2 text-primary">For Artists</h2>
          <p className="text-secondary">Manage bookings, showcase your work, and grow your business with ArtistDesk.</p>
        </div>
      </div>
      <div className="mt-10 flex justify-center gap-8">
        <a href="/about" className="text-secondary text-lg font-normal hover:text-primary transition">About Us</a>
        <a href="/contact" className="text-secondary text-lg font-normal hover:text-primary transition">Contact Us</a>
      </div>
    </div>
    <Footer />
  </div>
  );
};

export default Home;
